/**
 * Shared utilities for the OzPol Transparent donations feature.
 */

/** Format an AUD amount to a compact string (e.g. $1.2M, $450K) */
export const fmt = (n) => {
  if (n == null) return "—";
  if (n === 0) return "$0";
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(n < 10_000_000 ? 2 : 1)}M`;
  if (n >= 1_000) return `$${Math.round(n / 1_000)}K`;
  return `$${n.toLocaleString()}`;
};

/** Visual styles for each HHI concentration band */
export const HHI_STYLE = {
  "Highly Concentrated":    { bg: "#FEE2E2", color: "#991B1B", border: "#EF4444" },
  "Moderately Concentrated":{ bg: "#FEF3C7", color: "#92400E", border: "#F59E0B" },
  Diversified:              { bg: "#D1FAE5", color: "#065F46", border: "#10B981" },
};
